import { IonCol, IonGrid, IonRow } from '@ionic/react';
import equal from 'deep-equal';
import { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';

import ExpertSelect from '@components/fields/ExpertSelect';
import styles from '@components/forms/AdminJourneyFilters.module.css';
import Form from '@components/forms/Form';
import useMyExpert from '@hooks/useMyExpert';

type FormData = {
  expertId: string;
};

export type Filters = FormData;

type Props = {
  filters: Filters;
  onChange: (filterValues: FormData) => void;
};

const ExpertsFilters = ({ filters, onChange }: Props) => {
  const intl = useIntl();
  const myExpert = useMyExpert();

  const [query, setQuery] = useQueryParams({
    expertId: withDefault({ ...StringParam, urlName: 'expertExpertId' }, filters.expertId),
    expertName: withDefault(
      { ...StringParam, urlName: 'expertExpertName' },
      intl.formatMessage({ id: 'dictionary.me' })
    )
  });

  const initialValues: FormData = useMemo(() => ({ ...filters, ...query }), [filters, query]);

  const form = useForm<FormData>({
    defaultValues: initialValues,
    mode: 'onChange'
  });

  const expertId = form.watch('expertId');

  useEffect(() => {
    const values = { expertId };
    if (!equal(values, filters) || !query.expertName) {
      setQuery({ ...query, ...values });
      onChange(values);
    }
  }, [expertId, filters, myExpert, onChange, query, setQuery]);

  return (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <Form className={styles.form + ' ' + styles.noMarginTop} hookForm={form} onSubmit={() => {}}>
      <IonGrid>
        <IonRow className="ion-align-items-center">
          <IonCol size="4">
            <ExpertSelect<FormData>
              allowAny={false}
              control={form.control}
              error={form.formState.errors.expertId}
              initialOption={{ label: query.expertName ?? undefined, value: query.expertId ?? null }}
              label={intl.formatMessage({ id: 'forms.carePlansFilters.expertLabel' })}
              name="expertId"
              onSelection={(option: { label: string }) => {
                setQuery({ ...query, ...{ expertName: option.label } });
              }}
              replaceMyExpertWithMe
            />
          </IonCol>
        </IonRow>
      </IonGrid>
    </Form>
  );
};

export default ExpertsFilters;
